<div class="modal-header">
	<h4 class="modal-title pull-left">{{ "CROP_IMAGE.TITLE" | translate }}</h4>
	<button
		type="button"
		class="btn-close close pull-right"
		aria-label="Close"
		(click)="closeModal()"
	>
		<span aria-hidden="true" class="visually-hidden">&times;</span>
	</button>
</div>
<div class="modal-body">
	<image-cropper
		[imageFile]="file"
		[roundCropper]="roundCropper"
		format="png"
		(imageCropped)="imageCropped($event)"
		[resizeToWidth]="widthToResizeImage"
	></image-cropper>
	<div class="row mt-2">
		<div class="col-md-6 col-12">
			<button (click)="changeImage()" class="btn btn-primary w-100">
				<i class="bi bi-check-lg me-1"></i>
				{{ "CROP_IMAGE.CONFIRM_BUTTON" | translate }}
			</button>
		</div>

		<div class="col-md-6 col-12">
			<button (click)="closeModal()" class="btn btn-danger w-100">
				<i class="bi bi-x-lg me-1"></i>
				{{ "CROP_IMAGE.CANCEL_BUTTON" | translate }}
			</button>
		</div>
	</div>
</div>
